export default __webpack_public_path__ + "static/about-pinbar-5c1f0d311ae75067eff1ed1e8209ddb0.png";